/* eslint-disable prefer-const */
function scrollToElement(id: string) {
  let element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });
  }
}
export default scrollToElement;
